module.exports = __webpack_public_path__ + "static/media/developers.db5777ec.jpg";